import { DiscountKind } from "../../common/discount-kind";
import { DocumentItemAmountsSource } from "../../document/document-item-amounts-source";

export class PurchaseDocumentItemDTO {
	public no: number;
	public productId: number | null;
	public productName: string | null;
	public quantity: number;
	public unitId: number;
	public price: number;
	public vatRateId: number;
	public discountKind?: DiscountKind;
	public discountValue?: number;
	public pkwiu: string | null;
	public cnCode: string | null;
    public barCode: string;
    public symbol: string;
	public note: string | null;
	public jpkVatProductGroup: string;
	public relatedInventoryItemsIds: number[];
	public includesInventoryControl: boolean;
	public adjustedItemId?: number | null;
}

export class PurchaseDocumentGetItemDTO extends PurchaseDocumentItemDTO {
	public adjusted: boolean;
	public unitSymbol: string;
	public zal15: boolean;
	public index: string;
	public amountsSource: DocumentItemAmountsSource;
	public unitGrossPriceAfterDiscount: number;
	public unitGrossPrice: number;
	public unitNetPriceAfterDiscount: number;
	public unitNetPrice: number;
	public grossValueAfterDiscount: number;
	public grossValue: number;
	public netValueAfterDiscount: number;
	public netValue: number;
	public vatValueAfterDiscount: number;
	public vatValue: number;
	public inventoryTotalCost?: number;
	public inventoryUnitCost?: number;
	public id: number;
}
